let priceFormat = (value, unit) => {
    if(!value) return unit + '0.00';

    var intPart = Math.floor(value); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

    var floatPart = ".00"; //预定义小数部分
    var value2Array = value.split(".");

    //=2表示数据有小数位
    if(value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分

        if(floatPart.length == 1) { //补0
            return unit + intPartFormat + "." + floatPart + '0';
        } else {
            return unit + intPartFormat + "." + floatPart;
        }

    } else {
        return unit + intPartFormat + floatPart;
    }
}

let dateFormat = (value,type) => {
    if(!value) return '';
    var date = new Date(value);
    if (isNaN(date)) {
        return value;
    }
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month >= 10 ? month : "0" + month;
    var day = date.getDate();
    day = day >= 10 ? day : "0" + day;
    var hour = date.getHours();
    hour = hour >= 10 ? hour : "0" + hour;
    var minute = date.getMinutes();
    minute = minute >= 10 ? minute : "0" + minute;
    var second = date.getSeconds();
    second = second >= 10 ? second : "0" + second;
    switch(type){
        case "short": //短格式，如2011-05-06
            return year + "-" + month + "-" + day;
            break;
        case "long": //长格式，如2011-05-06 10:05:06
            return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            break;
        case "chinese": //中文格式，2011年05月06日 23:09
            return year + "年" + month + "月" + day + "日 " + hour + ":" + minute;
            break;
        default:
            return value;
            break;
    }
}

let arrayToStr = value => {
    if(!value){
        return '';
    } else{
        return value.join(',')
    }
}

export default {
    priceFormat,
    dateFormat,
    arrayToStr
}


// WEBPACK FOOTER //
// ./src/filter/filter.js